import { motion } from 'framer-motion'
import {
  ShoppingCart, Store, Package, ClipboardList, Layers,
  Truck, CheckCircle, Archive, LogOut, CreditCard
} from 'lucide-react'
import { supplyChainProcess } from '../../data'

export function HomeProcess() {
  const getIcon = (icon: string) => {
    switch (icon) {
      case 'shopping-cart': return <ShoppingCart className="w-6 h-6 text-primary-500" />;
      case 'store': return <Store className="w-6 h-6 text-primary-500" />;
      case 'package': return <Package className="w-6 h-6 text-primary-500" />;
      case 'clipboard-list': return <ClipboardList className="w-6 h-6 text-primary-500" />;
      case 'layers': return <Layers className="w-6 h-6 text-primary-500" />;
      case 'truck': return <Truck className="w-6 h-6 text-primary-500" />;
      case 'check-circle': return <CheckCircle className="w-6 h-6 text-primary-500" />;
      case 'archive': return <Archive className="w-6 h-6 text-primary-500" />;
      case 'log-out': return <LogOut className="w-6 h-6 text-primary-500" />;
      case 'credit-card': return <CreditCard className="w-6 h-6 text-primary-500" />;
      default: return null;
    }
  }

  return (
    <section className="section-padding">
      <div className="container-custom">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="text-3xl md:text-4xl font-bold mb-4"
          >
            供应链管理流程
          </motion.h2>
          <motion.p
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
            className="text-lg text-gray-600 max-w-2xl mx-auto"
          >
            从学校下单到财务结算，全程可视化管理，确保每一个环节都可控可追溯
          </motion.p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-1 bg-gray-200 transform -translate-x-1/2"></div>
          <div className="space-y-12">
            {supplyChainProcess.map((step, index) => (
              <motion.div
                key={step.id}
                initial={{ y: 50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1, ease: 'easeOut' }}
                className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center`}
              >
                <div className="md:w-1/2 p-4">
                  <div className={`text-${index % 2 === 0 ? 'left' : 'right'}`}>
                    <h3 className="text-xl font-semibold mb-3">{step.title}</h3>
                    <p className="text-gray-600">{step.description}</p>
                  </div>
                </div>

                <motion.div
                  initial={{ scale: 0.8, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.1 + 0.2, ease: 'easeOut' }}
                  className="relative z-10 flex items-center justify-center w-12 h-12 bg-white border-4 border-primary-500 rounded-full shadow-lg mb-4 md:mb-0"
                >
                  {getIcon(step.icon)}
                </motion.div>

                <div className="md:w-1/2 p-4">
                  <div className="h-24 md:h-auto"></div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
